import * as React from 'react';
import NoteCell from './noteCell';
import Date from '../getDate';

const NoteGroup = ({ data, extraData }) => {
    return (
        <div className="noteListingGroup detailListingGroup">

            <div className="date"><Date inputDate={data} /></div>
            {data.data.map((d) => {
                return <React.Fragment key={d.id}><NoteCell data={d.data} extraData={extraData} /></React.Fragment>
            })}
        </div>
    );
};

export default NoteGroup;